import PropTypes from "prop-types";
import InputSearchTag from "core/inputs/input-search/InputSearchTag";
import { useDybContext } from "api/external-apis/dyb/DybProvider";
import { formatNamesOptions } from "components/form/CommonInputs";
import { CONSULTANT_FORM_PLACEHOLDERS, FORM_INFO } from "constants/forms";
import { TAG_TYPES } from "constants/constants";
import { buildDybProfileUrl } from "utils/helper";

// DoYouBuzz-only picker set up like DoyoubuzzForm; dyb_id is null for server-saved candidates.
const FafCandidateSearch = ({ candidate, onChange, dataTestId, disabled }) => {
  const { searchUsersByName, usersByName, loadDybList } = useDybContext();

  const selectedOptions = candidate
    ? [
        {
          value: candidate.dyb_id ?? candidate.email,
          label: [candidate.first_name, candidate.last_name]
            .filter(Boolean)
            .join(" "),
        },
      ]
    : [];

  const select = ([option]) => {
    const person = usersByName?.find((p) => p.id === option?.value);
    if (!person) return;
    onChange({
      dyb_id: person.id,
      first_name: person.firstname,
      last_name: person.lastname,
      email: person.email,
    });
  };

  return (
    <InputSearchTag
      // "dyb" is a mode switch, not a DOM id: InputSearchPopup keeps server results unfiltered.
      id="dyb"
      dataTestId={dataTestId}
      disabled={disabled}
      getOptions={(search) => searchUsersByName({ search })}
      limitChoice={1}
      minLength={2}
      onDelete={() => onChange(null)}
      onTagClick={
        candidate?.dyb_id
          ? () =>
              window.open(
                buildDybProfileUrl(candidate.dyb_id),
                "_blank",
                "noopener,noreferrer"
              )
          : undefined
      }
      options={formatNamesOptions({ list: usersByName })}
      placeholder={CONSULTANT_FORM_PLACEHOLDERS.dyb_showcase_id}
      popup={FORM_INFO.candidate.popup}
      selectedOptions={selectedOptions}
      setValue={select}
      type={TAG_TYPES.PEOPLE}
      loadDybList={loadDybList}
    />
  );
};

FafCandidateSearch.propTypes = {
  candidate: PropTypes.shape({
    dyb_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    email: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
  dataTestId: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};

export default FafCandidateSearch;
